export default [
  {
    path: '/yearbill',
    name: 'yearBill',
    component: resolve => {
      require(['@/views/yearbill/index'], resolve)
    },
    meta: {
      title: '拍拍贷周年庆账单'
    }
  }
]
